import { css } from "styled-components";

// Aumenta os alvos de toque dos controles do Ant Design (3.x) em dispositivos
// com ponteiro "coarse" (tablet/celular). Altura de 44px segue o recomendado
// por Apple HIG / Material. Fonte de 16px evita zoom automático do iOS.
export const touchFriendlyControls = css`
  @media (pointer: coarse) {
    .ant-input {
      height: 44px;
      font-size: 16px;
    }

    .ant-input-number {
      height: 44px;
      font-size: 16px;
    }
    .ant-input-number-input {
      height: 42px;
    }

    .ant-select-selection--single {
      height: 44px;
    }
    .ant-select-selection--single .ant-select-selection__rendered {
      line-height: 42px;
    }
    .ant-select-selection--multiple {
      min-height: 44px;
      padding-top: 5px;
    }

    .ant-btn {
      min-height: 44px;
    }
    .ant-btn-circle {
      min-width: 44px;
    }

    .ant-table-small > .ant-table-content .ant-table-tbody > tr > td {
      padding: 12px 8px;
    }
  }
`;
